import React, { useEffect, useMemo, useState } from "react";
import FormLabel from "../../../common/FormLabel"
import { Col, Container, Form, Row } from 'react-bootstrap';
import { guardianSignUpErrors } from "../../../../constants/error.constants";
import { useForm } from "react-hook-form";
import FormInput from "../../../common/FormInput";
import { ErrorMessage } from "@hookform/error-message";
import LoadButton from "../../../common/LoadButton";
import Select from 'react-select';
import { onboardingViewModel } from "../../onboarding/onboarding.view.model";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import 'react-datepicker/dist/react-datepicker.css';
import ReactFlagsSelect from "react-flags-select";
import countryList from 'react-select-country-list'
import 'react-phone-input-2/lib/style.css'
import CountryJson from '../../../../assets/json/CountryCodes.json';
import { getGeolocationData } from "../../../../utils/utils";
import './guardian-invite.css';
import { useRecoilState } from "recoil";
import { campTribesAtom } from "../../../../atoms/camp.atom";

export default function GuardianInviteModal(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [relationship, setRelationship] = useState('');
    const list = countryList().getData();
    const [selected, setSelected] = useState("");
    const [selectedPhoneCode, setSelectedPhoneCode] = useState('');
    const [selectedCountryName, setSelectedCountryName] = useState('');
    const [guardianName, setGuardianName] = useState('');
    const [guardianEmail, setGuardianEmail] = useState('');
    const [tribeCode, setTribeCode] = useState(props?.groupCode);
    const [tribeListOptions, setTribeListOptions] = useState([]);
    const [campTribes, setCampTribes] = useRecoilState(campTribesAtom);

    useEffect(() => {
        if (props?.fromDashboard === true) {
            setTribeListOptions(campTribes?.map((obj) => {
                return { value: obj?.group_code, label: obj?.name }
            }));
        }
    }, [props.fromDashboard])

    const onSelect = (code) => {
        setSelected(code)
        setSelectedCountryName(list.filter((data) => data.value === code))
        const tempPhone = phoneCodeOptions[phoneCodeOptions.findIndex(obj => obj.country_code === code)]
        setSelectedPhoneCode(tempPhone.value)
    };

    const showSelectedLabel = false;
    const showSecondarySelectedLabel = false
    const selectedSize = 30;
    const showOptionLabel = false;
    const showSecondaryOptionLabel = false;
    const optionsSize = 20
    const searchable = true;
    const searchPlaceholder = "";
    const alignOptionsToRight = false;
    const fullWidth = false;
    const disabled = false;

    const handlePhoneCodeChange = (e) => {
        setSelectedPhoneCode(e.value)
        setSelected(e.country_code)
        setSelectedCountryName(list.filter((data) => data.value === e.country_code))
    }

    const phoneCodeOptions = CountryJson.map((obj) => {
        return { value: obj.dial_code, label: obj.dial_code, country_code: obj.code }
    })

    const getUserCountry = async () => {
        try {
            const res = await getGeolocationData()
            const filterdPhoneCodeOption = CountryJson.filter(obj => obj.code === res.country)
            setSelectedPhoneCode(filterdPhoneCodeOption[0]?.dial_code)
            setSelected(res.country)
            setSelectedCountryName(list.filter((data) => data.value === res.country))
        } catch (error) {
            console.log(error)
            setSelectedPhoneCode('+1')
            setSelected('US')
            setSelectedCountryName(list.filter((data) => data.value === 'US'))
        }
    }

    useEffect(() => {
        getUserCountry()
    }, [])

    const { register, handleSubmit, watch, setError, errors, getValues } = useForm({
        mode: 'onBlur',
    });

    const maxDate = useMemo(() => {
        let maxYearDate = new Date();
        maxYearDate.setFullYear(maxYearDate.getFullYear() - 5);
        return maxYearDate;
    });

    const [birthday, setBirthday] = useState(null);
    const [newBirthdayValue, setNewBirthdayValue] = useState(null);

    useEffect(() => {
        if (newBirthdayValue) {
            const selectedMonth = newBirthdayValue && (newBirthdayValue?.getUTCMonth() + 1) < 9 ? `0${newBirthdayValue?.getUTCMonth() + 1}` : newBirthdayValue && newBirthdayValue?.getUTCMonth() + 1
            setBirthday(`${newBirthdayValue.getFullYear()}-${selectedMonth}-${newBirthdayValue?.toString().substring(8, 10)}`);
        }
    }, [newBirthdayValue]);

    const relationOptions = [
        { value: 'Dad', label: 'Dad' },
        { value: 'Mom', label: 'Mom' },
        { value: 'Legal Guardian', label: 'Legal Guardian' },
    ]

    const handleRelationshipChange = (selection) => {
        setRelationship(selection.value);
    };

    const manufactureParams = (data) => {
        const params = {
            user: {
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                password: "taletree@123",
                relationship_to_kid: relationship,
                phone_number: selectedPhoneCode + data.phone,
                country_code: selected,
            },
            dependent: {
                first_name: data.child_name,
                last_name: data.last_name,
                username: `${data.child_name}576`,
                password: "taletree@123",
                signup: "app",
                profile: {
                    birthdate: birthday,
                    treehouse_unique_id: tribeCode,
                    school_name: props?.schoolName
                }
            }
        };
        return params;
    };

    const onSubmit = (data) => {
        const params = manufactureParams(data);
        if (!birthday) return
        if (!relationship) return
        if (!tribeCode) return
        setIsLoading(true);
        onboardingViewModel
            .inviteGuardian(params)
            .then((res) => {
                setGuardianName(`${params?.user?.first_name} ${params?.user?.last_name}`);
                setGuardianEmail(params?.user?.email);
                setIsLoading(false);
                props.setIsSuccess(true);
                props?.getData();
            })
            .catch((err) => {
                console.log(err)
                setIsLoading(false)
            });
    };

    window.verifyCallback = (res) => {
        setIsDisabled(false);
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 48,
            color: '#321b6d',
            fontWeight: '400',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#321b6d',
        }),
        menu: (provided) => ({
            ...provided,
        }),
    };

    const handleClear = () => {
        props.handleClose();
        props.setIsSuccess(false);
    }

    const handleTribeChange = (e) => {
        setTribeCode(e.value)
    }

    return (
      <div className="partner-wrapper-main">
        <Container>
          <div className="d-flex justify-content-start captain-modal">
            <div className="a-challenge-partner">
              {props.isSuccess ? (
                <Form className="mt-20 mb-10">
                  <p style={{ display: 'flex' }}>
                    Name:&nbsp;<span>{guardianName}</span>
                  </p>
                  <p style={{ display: 'flex', paddingTop: 0 }}>
                    Email:&nbsp;<span>{guardianEmail}</span>
                  </p>
                  <LoadButton
                    className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                    text="Close"
                    onClick={handleClear}
                  />
                </Form>
              ) : (
                <Form
                  className="mt-20 mb-10"
                  onSubmit={handleSubmit(() => onSubmit(getValues()))}
                >
                  {props?.fromDashboard && (
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>
                        Select Tribe<span className="text-danger">*</span>
                      </FormLabel>
                      <Select
                        options={tribeListOptions}
                        styles={customStyles}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: '6px',
                          colors: {
                            ...theme.colors,
                            primary: '#80e4e1',
                          },
                        })}
                        onChange={handleTribeChange}
                      />
                    </Form.Group>
                  )}
                  <Form.Row>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>
                        Guardian's First name
                        <span className="text-danger">*</span>
                      </FormLabel>
                      <FormInput
                        name="first_name"
                        className="form-input"
                        data-testid="first_name"
                        ref={register({
                          required: guardianSignUpErrors.first_name.required,
                        })}
                        placeholder="Enter first name"
                      />
                      <ErrorMessage
                        errors={errors}
                        name="first_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>
                        Guardian's Last name
                        <span className="text-danger">*</span>
                      </FormLabel>
                      <FormInput
                        name="last_name"
                        className="form-input"
                        data-testid="last_name"
                        ref={register({
                          required: guardianSignUpErrors.last_name.required,
                        })}
                        placeholder="Enter last name"
                      />
                      <ErrorMessage
                        errors={errors}
                        name="last_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>
                      Guardian's Email<span className="text-danger">*</span>
                    </FormLabel>
                    <FormInput
                      name="email"
                      className="form-input"
                      data-testid="email"
                      ref={register({
                        required: guardianSignUpErrors.email.required,
                      })}
                      placeholder="Enter email"
                    />
                    <ErrorMessage
                      errors={errors}
                      name="email"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <FormLabel>
                      Phone number<span className="text-danger">*</span>
                    </FormLabel>

                    <Form.Row>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'nowrap',
                          width: '100%',
                        }}
                      >
                        <span className="phonenum" style={{ width: '20%' }}>
                          <Select
                            className="phone-num1"
                            options={phoneCodeOptions}
                            placeholder={''}
                            styles={customStyles}
                            value={
                              phoneCodeOptions[
                                phoneCodeOptions.findIndex(
                                  (obj) => obj.value === selectedPhoneCode
                                )
                              ]
                            }
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: '6px',
                              colors: {
                                ...theme.colors,
                                primary: '#80e4e1',
                              },
                            })}
                            onChange={handlePhoneCodeChange}
                          />
                        </span>

                        <span
                          className="input-phonenum"
                          style={{ width: '100%' }}
                        >
                          <FormInput
                            className="input-modal"
                            name="phone"
                            placeholder="Enter phone number"
                            data-testid="phone"
                            type="tel" // Changed to 'tel' for phone input
                            ref={register({
                              required:
                                guardianSignUpErrors.phone_number.required,
                              pattern: {
                                value: /^[0-9]{10,15}$/, // Accepts numbers only, with a length between 10 and 15 digits
                                message: 'Invalid phone number', // Error message for invalid pattern
                              },
                            })}
                          />
                        </span>
                      </div>
                    </Form.Row>

                    <ErrorMessage
                      errors={errors}
                      name="phone"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="country-field">
                      Country<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Row>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'nowrap',
                          width: '100%',
                        }}
                      >
                        <span
                          className="country-flag"
                          style={{ width: '20%', marginTop: '5px' }}
                        >
                          <ReactFlagsSelect
                            selected={selected}
                            onSelect={onSelect}
                            showSelectedLabel={showSelectedLabel}
                            showSecondarySelectedLabel={
                              showSecondarySelectedLabel
                            }
                            selectedSize={selectedSize}
                            showOptionLabel={showOptionLabel}
                            showSecondaryOptionLabel={showSecondaryOptionLabel}
                            optionsSize={optionsSize}
                            placeholder=" "
                            searchable={searchable}
                            searchPlaceholder={searchPlaceholder}
                            alignOptionsToRight={alignOptionsToRight}
                            fullWidth={fullWidth}
                            disabled={disabled}
                          />
                        </span>

                        <span
                          className="input-phonenum"
                          style={{ width: '100%' }}
                        >
                          <FormInput
                            className="input-modal"
                            value={selectedCountryName[0]?.label}
                            disabled={true}
                          />
                        </span>
                      </div>
                      <ErrorMessage
                        errors={errors}
                        name="country"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Row>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>
                      Name of parents child in your class
                      <span className="text-danger">*</span>
                    </FormLabel>
                    <FormInput
                      name="child_name"
                      className="form-input"
                      data-testid="child_name"
                      ref={register({
                        required: guardianSignUpErrors.childName.required,
                      })}
                      placeholder="Please enter your child's name"
                    />
                    <ErrorMessage
                      errors={errors}
                      name="child_name"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                  <Form.Group className="mb-1" controlId="">
                    <FormLabel className="mt-2">
                      When is this child's date of birth?
                      <span className="text-danger">*</span>
                    </FormLabel>
                    <DatePicker
                      disableFuture
                      hiddenLabel
                      openTo="month"
                      views={['year', 'month', 'day']}
                      value={newBirthdayValue}
                      onChange={(newValue) => {
                        setNewBirthdayValue(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <Row>
                      <Col>
                        <label className="small text-danger">
                          {errors.dob}
                        </label>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>
                      Parent/Guardian relationship to child
                      <span className="text-danger">*</span>
                    </FormLabel>
                    <Select
                      options={relationOptions}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: '6px',
                        colors: {
                          ...theme.colors,
                          primary: '#80e4e1',
                        },
                      })}
                      onChange={handleRelationshipChange}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="age"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                  <Form.Group className="container-fluid">
                    <LoadButton
                      className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                      text="Send Invite"
                      isLoading={isLoading}
                      testid="submit"
                    />
                  </Form.Group>
                </Form>
              )}
            </div>
          </div>
        </Container>
      </div>
    );
}